











import Vue from 'vue';
import compagniaAssicurativaEdit from '@/components/commands/CompagniaAssicurativaEdit.vue';

export default Vue.extend({
    components: { compagniaAssicurativaEdit },
    methods: {
        close() {
            this.$router.push({
                name: 'CompagniaAssicurativaList',
            });
        },
    },
});
